import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { getWorkflowsModuleName } from './workflows.permissions';

export class WorkflowsPermissions {
  static GroupName = `${getWorkflowsModuleName()}.Workflows`;

  static getPermissions = getGroupPermissionFactory(WorkflowsPermissions.GroupName);

  static Permissions = {
    Create: WorkflowsPermissions.getPermissions(PermissionEnum.CREATE),
    Read: WorkflowsPermissions.getPermissions(PermissionEnum.READ),
    ReadAll: WorkflowsPermissions.getPermissions(PermissionEnum.READ_ALL),
    Update: WorkflowsPermissions.getPermissions(PermissionEnum.UPDATE)
  };
}
